.menu-button-open {
  background-color: var(--rds-background-tertiary) !important;
}

.menu {
  position: absolute;
  bottom: min(60px, 11vw);
  right: 24px;
  flex-direction: row;
  display: flex;
  border-radius: 8px;
  overflow: auto;
  background-color: var(--rds-background-primary);
  max-height: 40vw; /* prevent overflow on small screens */
}

.column {
  all: unset;
  min-width: 6rem;
  padding: min(3vw, 24px) min(4vw, 42px);
  margin-top: min(3vw, 24px);
}

.radio {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 8px;
  font-size: 1.1em;
  padding-top: min(10px, 1.5vw);
  cursor: pointer;
}

.radio-input {
  display: flex;
}

.radio-input input {
  appearance: none;
}

.radio-marker {
  display: grid;
  place-items: center;
}

.radio-label {
  opacity: 0.7;
  white-space: nowrap;
}

input + .radio-marker::before {
  content: '';
  width: 1.2rem;
  height: 1.2rem;
  background: center / 18px url('../../icons/svg/check-circle.svg') no-repeat;
  opacity: 0;
}

input:checked + .radio-marker::before {
  opacity: 1;
}

.selected {
  opacity: 1;
}
